import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { INDUSTRIES } from "@/data/site";

const Industries = () => (
  <section
    id="industries"
    data-testid="industries-section"
    className="scroll-mt-24 bg-slate-50 py-24 md:py-32 lg:py-40"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHeading
        overline="Industries"
        title="Solutions Shaped Around Your Sector"
        text="We work with startups, SMEs, restaurants, retailers, professional services and growing businesses across the UK and India."
      />

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {INDUSTRIES.map((industry, i) => (
          <Reveal key={industry.title} delay={i * 0.06}>
            <div
              data-testid={`industry-card-${industry.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group h-full rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-[box-shadow,transform,border-color] duration-500 hover:-translate-y-1 hover:border-electric/30 hover:shadow-xl"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-electric/10 transition-transform duration-500 group-hover:scale-110">
                <industry.icon className="h-6 w-6 text-electric" strokeWidth={1.5} />
              </div>
              <h3 className="mt-6 font-display text-lg font-medium text-slate-900">
                {industry.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{industry.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <div className="flex flex-col items-start justify-between gap-6 rounded-2xl border border-electric/20 bg-electric/5 p-8 md:flex-row md:items-center">
          <p className="max-w-xl font-display text-lg text-slate-800">
            Don't see your industry?{" "}
            <span className="text-slate-600">
              We can build a solution around your business.
            </span>
          </p>
          <a
            href="#contact"
            data-testid="industries-talk-to-team-btn"
            className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-electric px-7 py-3.5 text-sm font-medium text-white transition-[background-color,box-shadow,transform] duration-300 hover:scale-[1.02] hover:bg-electric-bright hover:shadow-[0_0_24px_rgba(37,99,235,0.4)] active:scale-95"
          >
            Talk To Our Team
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Industries;
